import api from "./api";

// Matches the same "range" values already used by the history
// dropdown (today/yesterday/week/month/lastmonth/year).
export const getRangeSummary = (serial, range) =>
    api.get(`/stats/range-summary/${serial}`, { params: { range } });
